import { create } from 'zustand';
import { IMaterial } from '../../../core/models/disciplines';
import { createJSONStorage, persist } from 'zustand/middleware';

interface IMaterialInfo {
  module: string;
}

interface IMaterialRequestState {
  materials: IMaterial[];
  materialInfo: IMaterialInfo | null;
  setMaterials: (materials: IMaterial[]) => void;
  setMaterialInfo: (materialInfo: IMaterialInfo) => void;
  setFavorite: (id: string) => void;
  resetMaterials: () => void;
}

export const useMaterialRequestStore = create<IMaterialRequestState>()(
    (set, get) => ({
      materials: [],
      materialInfo: null,
      setMaterials: (materials: IMaterial[]) => set({ materials }),
      setMaterialInfo: (materialInfo: IMaterialInfo) => set({ materialInfo }),
      setFavorite: (id: string) => set({ materials: get().materials.map((it: IMaterial) => it._id === id ? { ...it, favorite: !it.favorite } : it) }),
      resetMaterials: () => set({ materials: [], materialInfo: null }),
    })
);